export class BaseError extends Error {

  constructor(message: string) {
    super(message);

    // Set the prototype explicitly.
    // As specified in the documentation in TypeScript
    // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, BaseError.prototype);
  }

  toJSON() {
    const alt = {};

    Object.getOwnPropertyNames(this).forEach((key) => {
      alt[key] = this[key];
    }, this);

    return alt;
  }
}